<template>
    <div class="question-wrapper">
        <media-files v-if="item.files.length > 0" :files="item.files" />

        <p class="question">
            {{ item.title }}
        </p>

        <span class="text-subtitle-1">Выберите один вариант ответа</span>

        <div class="answer-wrapper" ref="answerWrapper">
            <div
                v-for="(it, key) in item.answers"
                :key="'B'+key"
                class="answer"
                :ref="`answer-${key}`"
                :class="{
                    'activeAnswer selectAnswer': activeIndex === key,
                    'border-top-left-radius-7': key === 0,
                    'border-bottom-left-radius-7': key === (item.answers.length - 1)
                }"
                @click="!viewBtnNext ? activeIndex = key : ''"
            >
                {{ it.title }}
            </div>
        </div>

        <v-expand-transition>
            <div
                v-if="flag"
                class="block-text-information text-left subtitle-1 font-weight-medium mt-2"
                :class="{
                    'error-text': flagError,
                    'success-text': flagSuccess,
                }"
            >
                {{ text }}
            </div>
        </v-expand-transition>

        <v-expand-transition>
            <div class="btn-block mb-2" v-if="activeIndex || activeIndex === 0">
                <v-btn :loading="loadCheck" :disabled="viewBtnNext" @click="checkQusest(activeIndex)" width="100%" color="blue darken-2" :dark="!viewBtnNext" elevation="2">Проверить результат</v-btn>

                <v-expand-transition>
                    <v-btn class="mt-4" v-if="viewBtnNext && stepModal !== 10" @click="nextQuestion()" width="100%" :color="answeredСorrectly ? 'success' : '#ed4040'" dark elevation="2">Дальше</v-btn>
                    <v-btn class="mt-4" v-if="viewBtnNext && stepModal === 10" @click="$emit('getEstimation')" width="100%" color="primary" dark elevation="2">Получить оценку</v-btn>
                </v-expand-transition>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
import party from 'party-js'
import mediaFiles from '../../../../components/TaskMediaFiles.vue'
import { mapActions } from 'vuex'

export default {
    components: { mediaFiles },
    props: {
        item: { type: Object, required: true },
        apiUrl: { type: String, required: true },
        stepModal: { type: Number, required: true },
    },
    data: () => ({
        flag: false,
        flagError: false,
        flagSuccess: false,
        text: '',
        activeIndex: null,
        viewBtnNext: false,
        answeredСorrectly: false,
        loadCheck: false
    }),
    methods: {
        ...mapActions({
            randomGenerate: 'tests/randomGenerate'
        }),
        nextQuestion() {
            this.$emit('nextStep')
        },
        checkQusest(ind) {
            this.loadCheck = true;

            this.$http.get(`${this.apiUrl}TestTask/GetQuestionAnswers?id=${this.item.id}`)
            .then((res) => {
                // удаляем у ответа боковую синюю полоску и переключаем на
                this.$refs[`answer-${ind}`][0].classList.remove('activeAnswer')

                // если ответ правильный
                if(this.item.answers[ind].id === res.data[0].id) {
                    this.randomGenerate('correctlyAnswered').then((res) => {
                        this.text = res;
                    })

                    this.$emit('addPercentageOfPassing');
                    this.answeredСorrectly = true;

                    // зеленную если успешно и вкл конфети
                    this.$refs[`answer-${ind}`][0].classList.add('successAnswer', 'successText')
                    this.flag = true;
                    this.flagError = false;
                    this.flagSuccess = true;
                    
                    party.confetti(this.$refs.answerWrapper, {
                        count: party.variation.range(100, 150),
                        size: party.variation.range(0.6, 1.4),
                    });
                } else {
                    this.randomGenerate('wrongAnswer').then((res) => {
                        this.text = res;
                    })
                    
                    this.answeredСorrectly = false;
                    let indexCorrect = this.item.answers.findIndex((f) => f.id === res.data[0].id);
                    this.$refs[`answer-${indexCorrect}`][0].classList.add('successAnswer', 'successText')
                    this.$refs[`answer-${ind}`][0].classList.add('errorAnswer')
                    this.flag = true;
                    this.flagError = true;
                    this.flagSuccess = false;
                }
                this.$emit('save', {item: this.item, ind}, 0);
                this.loadCheck = false;
                this.viewBtnNext = true;
            })

            // this.$emit('scroll')
        }
    }
}
</script>

<style scoped>
.btn-block {
    width: 100%;
    margin-top: 25px;
}
.block-text-information {
    width: 100%;
}
.error-text {
    color: #ed4040;
}
.success-text {
    color: #4caf50;
}
.question-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.question {
    margin: 8px 0 20px;
    font-size: 20px;
    line-height: 28px;
    width: 100%;
    text-align: left;
}
.answer-wrapper {
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(230, 230, 230);
    border-radius: 8px;
    font-family: "Proxima Nova", sans-serif;
    width: 100%;
}
.answer {
    display: flex;
    flex-direction: column;
    -webkit-box-pack: justify;
    justify-content: space-between;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0px;
    border-bottom: 1px solid rgb(230, 230, 230);
    padding: 10px 10px 10px 12px;
    cursor: pointer;
    color: rgb(0, 0, 0);
    position: relative;
}
.selectAnswer {
    background-color: rgb(243, 243, 243);
}

.border-top-left-radius-7::before {
    border-top-left-radius: 7px;
}
.border-bottom-left-radius-7::before {
    border-bottom-left-radius: 7px;
}
.activeAnswer::before {
    position: absolute;
    content: "";
    display: block;
    top: 0px;
    left: 3px;
    width: 10px;
    bottom: 0px;
    box-shadow: rgb(25 118 210) -4px 0px;
}

.successAnswer::before {
    position: absolute;
    content: "";
    display: block;
    top: 0px;
    left: 3px;
    width: 10px;
    bottom: 0px;
    box-shadow: rgb(78, 180, 84) -4px 0px;
}
.successText {
    color: #4caf50;
}
.errorAnswer::before {
    position: absolute;
    content: "";
    display: block;
    top: 0px;
    left: 3px;
    width: 10px;
    bottom: 0px;
    box-shadow: rgb(237, 64, 64) -4px 0px;
}

.answer:hover {
    background-color: rgb(245, 245, 245);
}
.answer:first-child {
    border-radius: 8px 8px 0px 0px;
}
.answer:last-child {
    border-radius: 0px 0px 8px 8px;
    border-bottom: none;
}

@media screen and (max-width: 960px) {
    .question {
        margin-top: 0;
    }
}
</style>